














































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import { DiscountsMixin } from '@shared/mixins/discounts'
import { SuperMixin } from '../../category.mixin'

@Component({
  filters: {
    prefixSpu(value: any) {
      return value.promotionName || value.couponName || ''
    },
    distanceStr(item: any) {
      return item.distance > 60000 ? '>60km' : item.distanceStr
    },
  },
})
export default class TentantComponent extends Mixins(DiscountsMixin, SuperMixin) {
  @Prop({ type: Boolean, default: false }) readonly showEntity!: boolean
  @Prop({ type: Boolean, default: false }) readonly showEmpty!: boolean
  @Prop({ type: Array, default: [] }) readonly list!: any[]

  toShop(item: any) {
    const { businessId } = item
    this.$router.push({ name: 'shop', query: { businessId } })
  }
  hasDiscounts(item: any) {
    // 判断是否有优惠
    const self: any = this
    return self && self.$options && self.$options?.filters['discounts'](item)
  }
}
